export default "__VITE_ASSET__Aj7Tit8w__"